import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Trans } from 'react-i18next';

const Timeline = ({ activeStep = 1, steps = [1, 2, 3], goToStep = () => {} }) => (
  <ul className="contact-form__timeline">
    {steps.map((step, key) => (
      <li
        key={key}
        className={classNames('contact-form__timeline-item', {
          'contact-form__timeline-item--first': step === steps[0],
          'contact-form__timeline-item--last': step === steps[steps.length - 1],
          'contact-form__timeline-item--active': activeStep >= step,
          'contact-form__timeline-item--clickable': activeStep > step,
          'contact-form__timeline-item--current': activeStep === step,
        })}
      >
        <span className="contact-form__timeline-bullet" />
        <span className="contact-form__timeline-label">
          <label
            className={'contact-form__timeline-label-inner'}
            onClick={() => {
              if (step < activeStep) {
                goToStep(step);
              }
            }}
          >
            <Trans>{`contact.professional.timeline.step-${step}`}</Trans>
          </label>
        </span>
      </li>
    ))}
  </ul>
);

Timeline.propTypes = {
  activeStep: PropTypes.number,
  goToStep: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.number),
};

export default Timeline;
